module.exports = __webpack_public_path__ + "static/media/body_tu5.31a9a031.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/body_tu5.png
// module id = 1584
// module chunks = 10